import { CommonContexts } from '@epam/uui-core';
import type { AppContext, TApi } from './data';

export const svc: Partial<CommonContexts<TApi, AppContext>> = {};
